import shareReducer from './reducers';

export const { init, clear } = shareReducer.actions;
